<template lang="pug">
#DeliveryDriverDetail
  b-card.delivery-card(v-if="delivery && delivery.address && !editDelivery")
    .d-flex.flex-row.text-secondary.mb-2(v-if="delivery")
      div {{ delivery.store ? delivery.store.name : 'No encontrado' }}
      span(style="font-weight:bold; color:#00C5AC" @click="SET_EDIT_DELIVERY(true)").ml-auto.mr-2 EDITAR
    h5 {{ delivery.address.street }}
    h5 {{ delivery.address.commune }}
    div.text-light-primary {{ delivery.customerName }}
    .contacto
      div.text-light-secondary(style="font-weight:bold") {{ delivery.customerPhone }}
      .botones-contacto
        a(:href="`tel:+56${delivery.customerPhone}`")
          .material-icons.text-light-secondary.icon phone
        font-awesome-icon.text-light-secondary.icon(:icon="['fab', 'whatsapp']" @click="abrirWhatsapp")
    b-form
      VFormField(
        :readOnly="readOnly"
        type="select"
        :title="labels.state"
        icon="store"
        :options="stateOptions"
        :invalid-feedback="getInvalidFeedback($v.form.state)"
        :state="$v.form.state && $v.form.state.$dirty ? !$v.form.state.$invalid : null"
        v-model="form.state"
      )
      VFormField(
        :readOnly="readOnly"
        type="input"
        :title="labels.receiverName"
        icon="person"
        :invalid-feedback="getInvalidFeedback($v.form.receiverName)"
        :state="$v.form.receiverName && $v.form.receiverName.$dirty ? !$v.form.receiverName.$invalid : null"
        v-model="form.receiverName"
      )
      VFormField(
        :readOnly="readOnly"
        type="input"
        :title="labels.receiverRut"
        icon="badge"
        :invalid-feedback="getInvalidFeedback($v.form.receiverRut)"
        :state="$v.form.receiverRut && $v.form.receiverRut.$dirty ? !$v.form.receiverRut.$invalid : null"
        v-model="form.receiverRut"
      )
      VFormField(
        :readOnly="readOnly"
        type="textarea"
        :title="labels.commentary"
        icon="assignment"
        :invalid-feedback="getInvalidFeedback($v.form.commentary)"
        :state="$v.form.commentary && $v.form.commentary.$dirty ? !$v.form.commentary.$invalid : null"
        v-model="form.commentary"
      )
      div(v-if="loadedImages.length > 0")
        div
          div(v-for="image in loadedImages")
            b-img(:src="`${image.url}`" fluid)

      .d-flex.flex-row.align-items-center(v-if="!readOnly" style="gap: 8px; width: 100%;")
        VFormField(
          inputId="fileInput"
          style="width: 100%;"
          type="file"
          :title="labels.images"
          placeholder="Selecciona Archivos"
          icon="file_upload"
          multiple
          accept="image/jpeg,image/png,image/gif"
          :invalid-feedback="getInvalidFeedback($v.images)"
          :state="$v.images && $v.images.$dirty ? !$v.images.$invalid : null"
          v-model="images"
          :capture="capture"
        )
        b-button.d-flex.py-0(
          style="align-items: center; height: 38px;"
          @click="openCamera"
          variant="primary"
          size="sm"
        )
          .material-icons camera_alt
    div(v-if="loadingImages")
      div Subiendo imágenes...
      div Puedes continuar utilizando la app te avisaremos cuando las imágenes estén listas
    b-button.boton(v-if="!readOnly" type="submit" @click="onSubmit" style="float: right;" :disabled="loading") Guardar
  DeliveryDriverEdit(v-show="delivery && delivery.address && editDelivery")
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MakeToastMixin from '../mixins/MakeToastMixin'
import DeliveryDriverEdit from './DeliveryDriverEdit'
import VFormField from '@/components/UI/VFormField'
import { required, minLength } from 'vuelidate/lib/validators'
import { getInvalidFeedback } from '@/shared/customValidations'
import heic2any from 'heic2any'
import Compressor from 'compressorjs'


export default {
  mixins: [MakeToastMixin],
  components: {
    DeliveryDriverEdit,
    VFormField
  },
  data() {
    return {
      state: null,
      loading: false,
      loadingImages: false,
      newLoadedImages: [],
      images: [],
      form: {
        state: null,
        receiverName: null,
        receiverRut: null,
        commentary: '',
        driver: this.delivery ? this.delivery.driver : null,
        driverId: this.delivery ? this.delivery.driverId : null,
        date: ''
      },
      stateOptions: [
        { value: null, text: 'Selecciona' },
        { value: 'entregado', text: 'Entregado' },
        { value: 'pendiente', text: 'Pendiente' },
        { value: 'rechazado', text: 'Rechazado' }
      ],
      capture: null
    }
  },
  methods: {
    ...mapActions(['getDelivery', 'updateDelivery', 'createDeliveryImage']),
    ...mapMutations(['SET_EDIT_DELIVERY']),
    openCamera() {
      this.capture = 'environment'
      this.$nextTick(() => {
        document.getElementById('fileInput').click()
        this.capture = null
      })
    },
    getInvalidFeedback,
    abrirWhatsapp() {
      let formatedPhone = this.delivery.customerPhone
      if (!formatedPhone) return
      formatedPhone = formatedPhone.trim()
      formatedPhone = formatedPhone.replace('+', '')
      formatedPhone = formatedPhone.slice(-8)
      window.open(`https://api.whatsapp.com/send?phone=569${formatedPhone}`, '_blank')
    },
    validate() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        this.$root.$bvToast.toast('Por favor los campos obligatorios', {
          title: 'Error',
          variant: 'danger'
        })
        return false
      }
      return true
    },
    async onSubmit() {
      if (!this.validate()) {
        return
      }
      this.loading = true
      this.form.date = this.delivery.date
      this.form.driverId = this.delivery.driverId
      this.form.lastUpdateState = new Date()
      const data = { ...this.form }
      const responseDelivery = await this.updateDelivery({ id: this.delivery.id, data })
      if (responseDelivery.status === 200) {
        this.makeSuccessToast('Estado del envío actualizado')
        await this.getDelivery({ id: this.$route.params.id })
        this.$emit('done')
        this.loadImages(this.images)
      } else if (responseDelivery.status >= 400) {
        this.makeDangerToast(responseDelivery.data.message || 'Error al editar el envío')
      }
      this.loading = false
    },
    async loadImages(rawFiles) {
      const files = await this.compressImages(rawFiles)

      this.loadingImages = true
      if (!files || files.length === 0) return
      const data = new FormData()
      for (const file of files) {

        data.append('files', file)
      }
      try {
        const response = await this.createDeliveryImage({ data, deliveryId: this.delivery.id })
        this.newLoadedImages = [...response.data]
        this.$bvToast.toast(`Imagenes del envío ${this.delivery.id} subidas correctamente`, {
          title: 'Imagenes subidas correctamente',
          variant: 'success',
          autoHideDelay: 5000
        })
      } catch (error) {
        this.$bvToast.toast(`Error al subir las imágenes del envío ${this.delivery.id}`, {
          title: 'Error al subir las imágenes',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
      this.loadingImages = false
    },
    async convertHeicIfNeeded(file) {
      // Detectar si es un archivo HEIC/HEIF
      const isHeic = file.type === 'image/heic' ||
        file.type === 'image/heif' ||
        file.name.toLowerCase().endsWith('.heic') ||
        file.name.toLowerCase().endsWith('.heif')

      if (!isHeic) {
        return file
      }

      try {
        // Convertir HEIC a JPEG
        const convertedBlob = await heic2any({
          blob: file,
          toType: 'image/jpeg',
          quality: 0.9
        })

        // Crear un nuevo archivo con el blob convertido
        const convertedFile = new File(
          [convertedBlob],
          file.name.replace(/\.(heic|heif)$/i, '.jpg'),
          { type: 'image/jpeg' }
        )

        return convertedFile
      } catch (error) {
        console.error('Error al convertir HEIC:', error)
        // Si falla la conversión, devolver el archivo original
        return file
      }
    },

    async compressImages(files) {
      // Primero convertir archivos HEIC si es necesario
      const convertedFiles = await Promise.all(
        files.map(file => this.convertHeicIfNeeded(file))
      )

      // Luego comprimir todos los archivos
      const compressedFiles = convertedFiles.map(file => {
        return new Promise((resolve, reject) => {
          new Compressor(file, {
            checkOrientation: false,
            quality: 0.4,
            convertSize: 5000,
            convertTypes: ['image/png', 'image/webp', 'image/jpg', 'image/jpeg'],
            maxHeight: 720,
            maxWidth: 720,
            success(result) {
              // Convertir Blob a File si es necesario
              if (result instanceof Blob && !(result instanceof File)) {
                const fileResult = new File(
                  [result],
                  file.name,
                  { type: result.type || file.type }
                )
                resolve(fileResult)
              } else {
                resolve(result)
              }
            },
            error(err) {
              reject(err)
            }
          })
        })
      })

      return Promise.all(compressedFiles)
    }
  },
  async created() {
    await this.getDelivery({ id: this.$route.params.id })
  },
  validations() {
    const formValidation = { state: { required } }
    const imageValidation = {}

    if (this.form.state === 'entregado') {
      formValidation.receiverName = { required }
      formValidation.receiverRut = { required }
      imageValidation.images = { required }
    }

    if (this.form.state === 'pendiente') {
      formValidation.commentary = { required }
      imageValidation.images = { required }
    }

    if (this.form.state === 'rechazado') {
      formValidation.commentary = { required }
      imageValidation.images = { required }
    }

    return { form: formValidation, ...imageValidation }
  },
  computed: {
    ...mapGetters(['delivery', 'editDelivery']),
    labels() {
      const deliveryLabels = {
        state: 'Estado',
        receiverName: 'Nombre',
        receiverRut: 'Rut',
        commentary: 'Comentario',
        images: 'Subir Imagenes (3 máximo)'
      }
      if (this.readOnly) {
        return deliveryLabels
      }
      if (this.form.state === null) {
        deliveryLabels.state = 'Estado (obligatorio)'
      }

      if (this.form.state === 'entregado') {
        deliveryLabels.state = 'Estado (obligatorio)'
        deliveryLabels.receiverName = 'Nombre (obligatorio)'
        deliveryLabels.receiverRut = 'Rut (obligatorio)'
        deliveryLabels.commentary = 'Comentario'
        deliveryLabels.images = 'Subir Imagenes (obligatorio)'
      }
      if (this.form.state === 'pendiente') {
        deliveryLabels.state = 'Estado (obligatorio)'
        deliveryLabels.commentary = 'Comentario (obligatorio)'
        deliveryLabels.images = 'Subir Imagenes (obligatorio)'
      }
      if (this.form.state === 'rechazado') {
        deliveryLabels.state = 'Estado (obligatorio)'
        deliveryLabels.commentary = 'Comentario (obligatorio)'
      }
      return deliveryLabels
    },
    readOnly() {
      return this.delivery.state !== null
    },
    validations() {
      const defaultValidation = {
        state: { required },
      }

      if (this.delivery.state === 'entregado') {
        defaultValidation.receiverName = { required }
        defaultValidation.receiverRut = { required }
      }

      if (this.delivery.state === 'pendiente') {
        defaultValidation.commentary = { required }
      }

      if (this.delivery.state === 'rechazado') {
        defaultValidation.commentary = { required }
      }

      return { form: { ...defaultValidation } }
    },
    loadedImages() {
      if (this.delivery) {
        return [...this.delivery.images, ...this.newLoadedImages]
      }
      return this.newLoadedImages
    },
  },
  watch: {
    images() {
      if (this.images.length > 3) {
        this.images = this.images.slice(0, 3)
      }
    },
    delivery() {
      this.form = {
        state: this.delivery?.state,
        receiverName: this.delivery?.receiverName,
        receiverRut: this.delivery?.receiverRut,
        commentary: this.delivery?.commentary,
      }
    }
  }
}
</script>
<style lang="scss">
.contacto {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 15px;
}

.icon {
  margin: 2px;
  cursor: pointer;
  font-size: 26px;
}

.botones-contacto {
  display: flex;
  width: 70px;
  justify-content: space-between;
  align-items: baseline;
}

.text {
  margin-left: 11px;
  margin-bottom: 10px;
}
</style>
